// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".row[data-v-fd4d029a]{margin:20px 0}.remove[data-v-fd4d029a]{position:absolute;top:0;right:5px}", ""]);
// Exports
module.exports = exports;
